module.exports = __webpack_public_path__ + "static/media/teamBg.dcc1c0d6.png";